import { useEffect, useMemo } from 'react'
import { useSbpBanks } from 'application/core/domain/useCase/sbp/useSbpBanks'
import { usePaymentStatus } from 'application/core/domain/useCase/payments/usePaymentStatus'
import { getUsedBanks } from 'features/SBP/bankUsed'

import { SBPChooseBank } from './paymentSteps/SBPChooseBank'
import { PaymentFail } from './paymentSteps/PaymentFail'
import { PaymentWaiting } from './paymentSteps/PaymentWaiting'

export type PaymentStep =
  | {
      step: 'sbp'
      data: {
        orderId: string
        formUrl: string
      }
    }
  | {
      step: 'sbp_wait'
      data: {
        orderId: string
        formUrl: string
      }
    }
  | {
      step: 'wait'
      data?: undefined
    }

type Props = {
  paymentStep: PaymentStep
  openOrderId: number
  onBackPress: () => void
  onPaymentPress: () => void
  onPaymentSuccess: (status: string, orderId: string) => void
}

export const CurrentPaymentStep = ({
  paymentStep,
  openOrderId,
  onBackPress,
  onPaymentPress,
  onPaymentSuccess,
}: Props) => {
  const usedBanks = useMemo(() => getUsedBanks(), [])
  const SBPBanks = useSbpBanks({ enabled: paymentStep.step === 'sbp' })
  const paymentStatus = usePaymentStatus(openOrderId, {
    enabled: paymentStep.step === 'sbp_wait',
  })

  useEffect(() => {
    if (
      paymentStep.data &&
      paymentStatus.data &&
      paymentStatus.data.status === 'Оплата прошла успешно'
    ) {
      onPaymentSuccess('success', paymentStep.data.orderId)
    }
  }, [paymentStatus.data, onPaymentSuccess, paymentStep.data])

  if (paymentStep.step === 'sbp') {
    return (
      <SBPChooseBank
        isLoading={SBPBanks.isLoading}
        orderId={paymentStep.data.orderId}
        banks={SBPBanks.data?.members}
        usedBanks={usedBanks}
        onBankSelected={onPaymentPress}
        onBankSelectionError={onBackPress}
      />
    )
  } else if (paymentStep.step === 'sbp_wait') {
    if (paymentStatus.data && paymentStatus.data.status === 'FAIL') {
      return <PaymentFail message={paymentStatus.data.message} onBackPress={onBackPress} />
    }

    return <PaymentWaiting onBackPress={onBackPress} />
  }

  return null
}
